module.exports = __webpack_public_path__ + "a06e5fe9ac1f95491de7e45ec536ccf8.svg";